<mat-toolbar class="matero-toolbar top-bar" style="height: auto; padding: 0 16px; width: 100%">
  <div class="top-bar-logo" (click)="openDashboardParameterless()"></div>

  <!-- Show search-filter buttons on larger screens -->
  <!-- Top bar menu buttons -->
  <div class="top-bar-central-items">
    <ng-container *ngFor="let entity of search_entities">
      <button
        [ngClass]="{ active: dashboard_.searchFilterType === entity.type }"
        *ngIf="entity.subcategories"
        mat-stroked-button
        (click)="openDashboard(entity.type)"
        [matTooltip]="entity.header_tooltip"
      >
        <span class="menu-item">{{ entity.search_entity_label }}</span>
      </button>
    </ng-container>
  </div>
  <div>
    <app-menu-profile></app-menu-profile>
  </div>
</mat-toolbar>
